import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  mobilePayUrl: {
    textAlign: "center",
},
  mobilePayQRCode: { 
     textAlign: "center",
  },
}));
